import BaseService from "./BaseService";

class UserService {
  static async list({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/users/list?${queryParams}`, "POST", {
      filters,
    });
  }

  static async export({ fileType, query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `/users/export/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async adminUserlist({ query }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/users?${queryParams}`);
  }

  static async managers() {
    return await BaseService.callAPI(`/users/managers`);
  }

  static async departments() {
    return await BaseService.callAPI(`/users/departments`);
  }

  static async designations() {
    return await BaseService.callAPI(`/users/designations`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/users`, "POST", data);
  }

  static async bulkCreate(data) {
    return await BaseService.callAPI(`/users`, "POST", data);
  }

  static async delete({ id }) {
    return await BaseService.callAPI(`/users/${id}`, "DELETE");
  }

  static async activate({ id }) {
    return await BaseService.callAPI(`/users/${id}/activate`, "PUT");
  }

  static async deactivate({ id }) {
    return await BaseService.callAPI(`/users/${id}/deactivate`, "PUT");
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/users/${id}`);
  }

  static async summary() {
    return await BaseService.callAPI(`/users/summary`);
  }

  static async update({ id, detailType, ...data }) {
    let url = `/users/${id}`;
    if (detailType === "personal_details") {
      url = `/users/${id}/personal-details`;
    } else if (detailType === "official_details") {
      url = `/users/${id}/official-details`;
    } else if (detailType === "role_details") {
      url = `/users/${id}/role-details`;
    } else if (detailType === "dynamic_details") {
      url = `/users/${id}/dynamic-details`;
    }
    return await BaseService.callAPI(url, "PUT", data);
  }

  static async downloadTemplate() {
    return await BaseService.callAPI(
      `/users/bulk/template/download`,
      "GET",
      null,
      { responseType: "blob" }
    );
  }

  static async importUsers({ file }) {
    const formData = new FormData();
    formData.append("file", file);
    return await BaseService.callAPI(
      `/users/bulk/import`,
      "POST",
      formData,
      {},
      { contentType: "multipart/form-data" }
    );
  }

  static async pendingAssignments({ id }) {
    return await BaseService.callAPI(`/users/assignment/pending/${id}`);
  }

  static async markUserAssignmentAsCompleted({ userId, id }) {
    return await BaseService.callAPI(
      `/users/assignment/mark/${userId}/completed/${id}`,
      "POST"
    );
  }
}

export default UserService;
